export default {
  getKeywordHistoryResult: (state) => state.keywordHistoryResult,
};
